const modelIdStr = `
1387224252483596289
1387224252483596290
1387224252483596291
1387224252483596292
1387224252483596293
1387224252483596294
1387224252483596295
1387224252483596296
1387224252483596297
1387224252483596298
1387224252483596299
1387224252483596300
1387224252483596301
1387224252483596302
1387224252483596303
1387224252483596304
1387224252483596305
1387224252483596306
1387224252483596307
1387224252483596308
1387224252483596309
1387224252483596310
1387224252483596311
1387224252483596312
1387224252483596313
1387224252483596314
1387224252483596315
1387224252483596316
1387224252483596317
1387224252483596318
1387224252483596319
1387224252483596320
1387224252483596321
1387224252483596322
1387224252483596323
1387224252483596324
1387224252483596325
1387224252483596326
1387224252483596327
1387224252483596328
1387224252483596329
1387224252483596330
1387224252483596331
1387224252483596332
1387224252483596333
1387224252483596334
1387224252483596335
1387224252483596336
1387224252483596337
1387224252483596338
1387224252483596339
1387224252483596340
1387224252483596341
1387224252483596342
1387224252483596343
1387224252483596344
1387224252483596345
1387224252483596346
1387224252483596347
1387224252483596348
1387224252483596349
1387224252483596350
1387224252483596351
1387224252483596352
1387224252483596353
1387224252483596354
1387224252483596355
1387224252483596356
1387224252483596357
1387224252483596358
1387224252483596359
1387224252483596360
1387224252483596361
1387224252483596362
1387224252483596363
1387224252483596364
1387224252483596365
1387224252483596366
1387224252483596367
1387224252483596368
1387224252483596369
1387224252483596370
1387224252483596371
1387224252483596372
1387224252483596373
1387224252483596374
1461256376561987585
1504386155458158594
1533705896948031489
1534102551484588033
1534402456337932289
1615162717063749634
1615163290857119745
1615163448990769154
1615163594386317313
1615163732689297409
1630075607910322176
1630075651480752128
1630076063906664448
1630076110115311616
1630076664665214976
1630076720818556928
1630091926730838016
1630091980086579200
1630092020821659648
1630092151319040000
1630092189063581696
1630092237138694144
1631214784890671104
1631214954021785600
1631214988209557504
1631215056316665856
1631215094509998080
1631215128987176960
1564504797510766592
1564506568673071104
1564508328301039616
1564511819086041088
1564511944336347136
1564512065090359296
1564512181629095936
1564512343428567040
1564514514119299072
1564515467543318528
1564515527878381568
`


export const modelIds = modelIdStr.split('\n')